var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "notification-wrapper" }, [
    _c(
      "div",
      { staticClass: "notification__pop__block" },
      _vm._l(_vm.announcements, function (notification, index) {
        return _c("div", { key: "notif_" + index, staticClass: "list" }, [
          _c("img", {
            attrs: {
              src: require("@/assets/images/calendar.webp"),
              alt: "Calendar",
            },
          }),
          _c("div", { staticClass: "time" }, [
            _c("span", [
              _vm._v(
                _vm._s(_vm.renderDateTime(notification.publishDateTime, "date"))
              ),
            ]),
            _c("span", [
              _vm._v(
                _vm._s(_vm.renderDateTime(notification.publishDateTime, "time"))
              ),
            ]),
          ]),
          _c("div", { staticClass: "desc-wrapper" }, [
            _c("div", { staticClass: "desc" }, [
              _vm._v(_vm._s(notification.message)),
            ]),
          ]),
        ])
      }),
      0
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }